import {
    Component,
    NgModule,
    OnInit,
    OnChanges,
    NgZone
} from '@angular/core';

import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import {iRoute, iRouteWaypoint, iRouteCordinate, iRouteSlides} from '../service/routes';
import {RoutsService} from '../service/route.service';
declare var google: any;

// just an interface for type safety.
interface iTimeLineEvent {
    left: number;
    name: string;
    number: number;
    selected?: boolean;
}

interface iRouteVM {
    name: string;
    selected?: boolean;
    center: iRouteCordinate;
    zoom?: number;
    route: iRoute;
}

@Component({
    selector: 'app-index',
    styles: [`
        #map {
            height: 500px;
        }
    `],
    template: `
        <div>
            <h2 class="map-timeline-headline">
                <strong>Period:</strong>
                {{period}}
            </h2>
            <div class="map-timeline">
                <div class="map-timeline-waypoints-wrapper">
                    <div class="map-timeline-waypoints">
                        <ol>
                            <li *ngFor="let timelineEvent of timelineEvents; let i = index">
                                <span [style.left.px]="timelineEvent.left"
                                      class="map-timeline-waypoint"
                                      [ngClass]="{'map-timeline-waypoint--selected': timelineEvent.selected }">
                                    <div class="map-timeline-waypoint-name">
                                        {{timelineEvent.name}}
                                    </div>
                                </span>
                            </li>
                        </ol>

                        <span class="map-timeline-progress" aria-hidden="true"
                              [style.transform]="safeProgress"></span>
                    </div>
                </div>
            </div>

            <div class="btn-group map-timeline-routebtns" role="group">
                <button *ngFor="let route of routesVM;"
                        type="button"
                        class="btn btn--sm"
                        [ngClass]="{'btn--secondary': !route.selected}"
                        (click)="centerRoute(route)">
                    {{route.name}}
                </button>
            </div>

            <div id="map"></div>

            <h2 class="map-timeline-medien"><strong>Media for</strong> {{name}}</h2>
            <slick-slider *ngIf="slides" [slides]="slides">
            </slick-slider>
        </div>
    `,
    providers: [RoutsService]
})

// solution from: http://stackoverflow.com/a/38882943/639035
export class IndexComponent implements OnInit {
    constructor(private zone: NgZone, private routeService: RoutsService, private sanitizer: DomSanitizer) {
    }

    private MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    private map: google.maps.Map = null;

    private iconFile = '/fileadmin/template/assets/img/pin-grey.png';
    private zIndex = 100;

    public timelineEvents: Array<iTimeLineEvent> = [];
    public progress: number = 0;

    public period: string = "";
    public months: Array<number> = [];
    public name: string = "";
    public slides: Array<iRouteSlides> = [];
    public routesVM: Array<iRouteVM> = [];

    public safeProgress = this.sanitizer.bypassSecurityTrustStyle("scaleX(0.5)");

    public selectMarker = (waypoint: iRouteWaypoint, index: number, count: number, routename: string) => {
        this.zone.run(() => {
            // the scale
            let scaling = 0;
            if (index != 0) {
                scaling = (1 / count * (index + 1 ));
            }
            this.safeProgress = this.sanitizer.bypassSecurityTrustStyle(`scaleX(${scaling})`);

            // slides
            this.slides = waypoint.slides;

            // timelinepoints
            for (let timelineEvent of this.timelineEvents) {
                timelineEvent.selected = waypoint.months.indexOf(timelineEvent.number) !== -1;
            }

            // text
            let startMonth = this.MONTHS[waypoint.months[0]];
            let endMonth = this.MONTHS[waypoint.months[waypoint.months.length - 1]];
            if (waypoint.months.length === 1) {
                this.period = `${startMonth} ${waypoint.startyear}`;
            } else if (waypoint.startyear === waypoint.endtyear) {
                this.period = `${startMonth} - ${endMonth} ${waypoint.startyear}`;
            } else {
                this.period = `${startMonth} ${waypoint.startyear} - ${endMonth} ${waypoint.endtyear}`;
            }

            // name
            this.name = waypoint.name;

            // select the right route
            for (let routeVM of this.routesVM) {
                routeVM.selected = (routeVM.name == routename);
            }
        });
    }


    private drawRout(route: iRoute): void {
        let createmarker = (waypoint: iRouteWaypoint, index: number, count: number) => {
            let cordiante = new google.maps.LatLng(waypoint.cordinate.lat, waypoint.cordinate.lng);

            if(waypoint.color == 1) {
                console.log(waypoint);
                this.iconFile = '/fileadmin/template/assets/img/pin-pink.png';
                this.zIndex = 9999;
            } else {
                this.iconFile = '/fileadmin/template/assets/img/pin-grey.png';
                this.zIndex = 100;
            }

            let marker = new google.maps.Marker({
                position: cordiante,
                map: this.map,
                icon: this.iconFile,
                optimized: false,
                zIndex: this.zIndex
            });
            marker.addListener('click', () => {
                this.selectMarker(waypoint, index, count, route.name);
            });
        }

        let waypoints: Array<iRouteCordinate> = [];
        // start and end point
        for (let i = 0; i < route.waypoints.length; i++) {
            waypoints.push(route.waypoints[i].cordinate);
            createmarker(route.waypoints[i], i, route.waypoints.length);
        }

        var flightPath = new google.maps.Polyline({
            path: waypoints,
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 2
        });
        flightPath.setMap(this.map);
    }

    public centerRoute(routeVM: iRouteVM): void {
        console.log("centerRoute %o", routeVM)
        this.map.setCenter(routeVM.center);
        this.map.setZoom(routeVM.zoom);


        this.zone.run(() => {
            this.selectMarker(routeVM.route.waypoints[0], 0, routeVM.route.waypoints.length, routeVM.route.name);
        });
    }

    ngOnInit() {
        this.routeService.getRoots().then(routes => {
            let itemspacing = 1000 / (this.MONTHS.length - 1);
            for (let _i = 0; _i < this.MONTHS.length; _i++) {
                // TODO: use translations
                var month = this.MONTHS[_i];
                let timeLineEvent: iTimeLineEvent = {
                    left: itemspacing * _i,
                    name: month,
                    number: _i
                }
                this.timelineEvents.push(timeLineEvent);
            }


            this.map = new google.maps.Map(document.getElementById('map'), {
                center: new google.maps.LatLng(0, 0),
                zoom: 2,
                minZoom: 1
            });

            for (let route of routes) {
                this.drawRout(route);
                this.routesVM.push({
                    name: route.name,
                    center: route.center,
                    zoom: route.zoom || 3,
                    route: route
                });
            }

            let defaultRoute = routes[0];
            this.selectMarker(defaultRoute.waypoints[0], 0, defaultRoute.waypoints.length, defaultRoute.name);
        });
    }
}




// WEBPACK FOOTER //
// ./assets_dev/ts/app/component/index.component.ts